"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.bulk.exceeded': 'No se pueden subir {itemsToAdd} archivos. Tienes {remainingSlots} espacios restantes de {limit} entradas máximas permitidas.',
};
